"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MainStyled = void 0;
const styles_1 = require("@mui/material/styles");
exports.MainStyled = (0, styles_1.styled)("main")(() => {
    return {
        height: "100%",
        "@media (min-width: 1280px)": {
            margin: "24px 100px 80px ",
        },
    };
});
